export default {
    methods: {
        async getFileContent(fileId) {
            return await this.$http.get(`/v2/file/${fileId}/affiliate_invoice`, {
                responseType: 'arraybuffer'
            });
        }
    }
};
